import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
export const styles = (theme: Theme) => {
	return ({
		dialogContent: {
			minWidth: 325, 
			minHeight: 225,
		},
		checkbox: {
			marginRight: 8,
		},
		autocomplete: {
			minWidth: 275,
		},
		autocompleteItem: {
			display: "flex",
			flexDirection: "column",
			alignItems: "stretch",
		},
		selectAll: {
			alignSelf: "flex-end",
		},
	} satisfies Record<string, CSSObject>);
};
